import { StyleSheet } from 'aphrodite/no-important';
import { color, iconUrl } from './vars';

export const playIcon = StyleSheet.create({
	icPlay: {
		display: 'block',
		width: '45px',
		height: '45px',
		background: `url(${iconUrl.icPlayMed})`,
		borderRadius: '50%',
		backgroundSize: '100%'
	},
	icPlayBig: {
		display: 'block',
		width: '68px',
		height: '68px',
		background: `url(${iconUrl.icPlayMed})`,
		borderRadius: '50%',
		backgroundSize: '100%'
	},
	icPlayTiny: {
		display: 'block',
		width: '25px',
		height: '25px',
		background: `url(${iconUrl.icPlayTiny})`,
		borderRadius: '50%',
		backgroundSize: '100%'
	},
	icPlayHover: {
		backgroundColor: color.black,
		transform: 'scale(1.05)'
	}
});

export const icons = StyleSheet.create({

	icCloseIconWhite:{
		background: `url(${iconUrl.closeIconWhite})`,
		display: 'block',
		width: '18px',
		height: '18px',
	},

	icUpNext: {
		background: `url(${iconUrl.upNext})`,
		display: 'block',
		width: '79px',
		height: '13px',
		marginBottom: '5px',
	},

	icFs: {
		background: `url(${iconUrl.fsWhite})`,
		display: 'block',
		backgroundSize: '59px',
		width: '59px',
		height: '35px',
	}
});

export const shareIcons = StyleSheet.create({
	inlineContainer:{
		display: 'inline-flex',
		marginBottom: '20px'
	},

	icFBShare:{
		background: `url(${iconUrl.fbShareRnd})`,
		':hover':{
			transform: 'scale(1.05)'
		}
	},
	icTwitterShare: {
		background: `url(${iconUrl.twitterShareRnd})`,
		':hover':{
			transform: 'scale(1.05)'
		}
	},
	icLinkShare:{
		background: `url(${iconUrl.linkShareRnd})`,
		':hover':{
			transform: 'scale(1.05)'
		},
		border: 'none',
		outline: 'none',
	},
	icEmailShare:{
		background: `url(${iconUrl.emailShareRnd})`,
		':hover':{
			transform: 'scale(1.05)'
		}
	},

	icShare: {
		display: 'block',
		width: '38px',
		height: '38px',
		marginRight: '10px'
	},

});

export const liveIcon = StyleSheet.create({
	icLive: {
		width: '29px',
		height: '13px',
		backgroundImage: `url(${iconUrl.icLive})`,
		backgroundSize: '100%'
	}
});

export const fsgoIcon = StyleSheet.create({
	white: {
		display: 'block',
		height: '100%',
		backgroundSize: '100%',
		backgroundImage: `url(${iconUrl.fsgoWhite})`,
	}
});

export const keyIcon = StyleSheet.create({
	white: {
		width: '24px',
		height: '10px',
		backgroundImage: `url(${iconUrl.icKey})`,
		backgroundSize: '100%',
		display: 'block'
	}
});



// WEBPACK FOOTER //
// ./react-app-src/shared/styles/icons.js